module.exports = __webpack_public_path__ + "img/new_title_img.34be624f.png";